export default __webpack_public_path__ + "static/media/headerIconLocation.f6c7d8e2.svg";